module.exports = __webpack_public_path__ + "static/media/no-poets-dont-own-words1.e1d4dc08.jpg";